import { Component, OnInit, Input } from '@angular/core';
import { CurrencyService } from 'src/app/util/currency.service';

@Component({
  selector: 'app-total-amount',
  templateUrl: './total-amount.component.html',
  styleUrls: ['./total-amount.component.css'],
})
export class TotalAmountComponent implements OnInit {
  @Input() amount: any;
  @Input() details: any;
  Currency;
  constructor(private curr: CurrencyService) {
    this.Currency = this.curr.getCurrency();
  }

  ngOnInit() {}
}
